<template>
  <!-- old mag2year -->
  <section class="footer_sns gradation_brown ">
    <div class="old_mag2year_container">
      <div id="section3" class="">
        <ul class="up_ul">
          <li>
            <a href="https://www.mag2.com/events/mag2year/2019/"
              >まぐまぐ大賞2019</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2018/"
              >まぐまぐ大賞2018</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2017/"
              >まぐまぐ大賞2017</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2016/"
              >まぐまぐ大賞2016</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2015/"
              >まぐまぐ大賞2015</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2014/"
              >まぐまぐ大賞2014</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2008/"
              >まぐまぐ大賞2008</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2007/"
              >まぐまぐ大賞2007</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2006/"
              >まぐまぐ大賞2006</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2005/"
              >まぐまぐ大賞2005</a
            >
          </li>
          <li>
            <a href="https://www.mag2.com/events/mag2year/2004/"
              >まぐまぐ大賞2004</a
            >
          </li>
        </ul>
      </div>
    </div>
  </section>
  <!-- /old mag2year -->
</template>

<script>
export default {}
</script>

<style scoped>
/* old mag2year */
.old_mag2year_container {
  width: 100%;
  margin: 0 auto;
  background-color: #222222;
}

#section3 {
  margin: 0 auto;
  padding: 58px 0;
  display: block;
  max-width: none;
  width: 100%;
  position: relative;
  max-width: 1200px;
}

#section3 ul.up_ul,
#section3 ul.down_ul {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  list-style: none;
  padding: 0;
  margin-bottom: 15px;
}
#section3 ul.down_ul {
  margin-bottom: 0;
}

#section3 ul.up_ul li,
#section3 ul.down_ul li {
  text-align: center;
}

#section3 ul.up_ul li {
  width: calc(25% - 5px);
  margin: 10px 0 0 5px;
}

#section3 ul.down_ul li {
  width: 19.5%;
}

#section3 ul.up_ul li a,
#section3 ul.down_ul li a {
  text-decoration: none;
  color: #fff;
  width: 100%;
  height: 100%;
  display: block;
  font-weight: 500;
  padding: 10px 5px;
  font-size: 14px;
  background-color: #373737;
}

#section3 ul.up_ul li a:hover,
#section3 ul.up_ul li a:active,
#section3 ul.down_ul li a:hover,
#section3 ul.down_ul li a:active {
  opacity: 0.8;
}
@media screen and (max-width: 769px) {
  #section3 ul.up_ul li {
    width: calc((100% / 2) - 10px);
    margin: 10px 0 0 5px;
  }
  #section3 ul.up_ul,
  #section3 ul.down_ul {
    margin: 0 auto 15px;
  }
}
@media screen and (max-width: 400px) {
  #section3 ul.up_ul li {
    width: 100%;
  }
}
</style>
